export const dynamicAttr = (key, value) => {
  const temp = {}
  temp[key] = value
  return value ? temp : {}
}